export class CommPlanJson {
    public commPlanId : any;
    public scEmpId : any;
    constructor(){
            this.commPlanId = null;
            this.scEmpId = [];
        }
}
